<p-progress-spinner
  [style]="{ width: size(), height: size() }"
  animationDuration="600ms"
  strokeWidth="4" />
